import {
  Activity01Icon,
  AlertCircleIcon,
  ArrowRight01Icon,
  BrainIcon,
  Cancel01Icon,
  CheckIcon,
  CreditCardIcon,
  Delete02Icon,
  ExternalLinkIcon,
  FlashIcon,
  GaugeIcon,
  InboxIcon,
  KeyRoundIcon,
  LockKeyholeIcon,
  LogOutIcon,
  MailCheckIcon,
  Menu01Icon,
  PlusIcon,
  RefreshCwIcon,
  Settings01Icon,
  ShieldCheckIcon,
  SlidersHorizontalIcon,
  SparklesIcon,
  Undo02Icon,
  UserGroupIcon,
} from "@hugeicons/core-free-icons";
import {
  HugeiconsIcon,
  type HugeiconsIconProps,
  type IconSvgElement,
} from "@hugeicons/react";

type IconProps = Omit<HugeiconsIconProps, "icon">;

function icon(iconData: IconSvgElement) {
  return function PresetIcon(props: IconProps) {
    return <HugeiconsIcon icon={iconData} strokeWidth={2} {...props} />;
  };
}

export const Activity = icon(Activity01Icon);
export const ArrowRight = icon(ArrowRight01Icon);
export const Brain = icon(BrainIcon);
export const Check = icon(CheckIcon);
export const CircleAlert = icon(AlertCircleIcon);
export const CreditCard = icon(CreditCardIcon);
export const ExternalLink = icon(ExternalLinkIcon);
export const Flash = icon(FlashIcon);
export const Gauge = icon(GaugeIcon);
export const Inbox = icon(InboxIcon);
export const KeyRound = icon(KeyRoundIcon);
export const LockKeyhole = icon(LockKeyholeIcon);
export const LogOut = icon(LogOutIcon);
export const MailCheck = icon(MailCheckIcon);
export const Menu = icon(Menu01Icon);
export const Plus = icon(PlusIcon);
export const RefreshCw = icon(RefreshCwIcon);
export const Settings = icon(Settings01Icon);
export const ShieldCheck = icon(ShieldCheckIcon);
export const SlidersHorizontal = icon(SlidersHorizontalIcon);
export const Sparkles = icon(SparklesIcon);
export const Trash2 = icon(Delete02Icon);
export const Undo2 = icon(Undo02Icon);
export const Users = icon(UserGroupIcon);
export const X = icon(Cancel01Icon);
